/**
* @Component Name: LineInfoComponent
* @Module: Home
* @Module Functionality : To display the customer line information
* @Creation Date: August 12,2017
* @Author: sbaireddy
* @Version: 1.0
*/
import { Component, Input, OnInit } from '@angular/core';

import { Customer } from '../../shared/modal/customer';

import { SharedService } from '../../shared/shared.service';
import { CustomerService } from '../../services/customer.service';

@Component({
    selector: 'line-info-cmp',
    //moduleId: module.id,
    templateUrl: 'line-info.component.html',
    styleUrls: ['line-info.component.css']
})

export class LineInfoComponent implements OnInit {
    private COMPONENT_NAME: string = 'LineInfoComponent';
    @Input() customer: Customer;

    constructor(
        public sharedService: SharedService,
        public customerService: CustomerService) {
    }

    /**
     * This function is used to initialize the directive/component after Angular
     * first displays the data-bound properties.It is invoked only once when the
     * directive is instantiated.Here it is initializing all the states, payment methods and card types
     * @returns void
     */
    ngOnInit(): void {
        const METHOD_NAME: string = 'ngOnInit()';
        console.log('AccountInfoComponent.ngOnInit()>>Start.');
    }
}
